import deepEqual from 'deep-equal'

export default deepEqual
